export const Signature = {
  explanation: 'Only class participants see your signature on Remind.',
};

export const DisabledComposerListItemCopy = {
  DISTRICT_IS_SELECTED:
    "To send a message to other recipients, first remove the district you've already selected",
  NONDISTRICT_RECIPIENT_IS_SELECTED:
    "To send a message to a district, first remove the other recipients you've already selected",
  SEND_TO_FEW_LIMIT_REACHED: (limit: number) =>
    `You can send to up to ${limit} classes, organizations, and individuals at once`,
};

export const ChatIneligibleCopy = {
  UNDER_13: (name: string) => ({
    h1: 'Students under age 13 cannot have conversations on Remind.',
    h2: `${name} will still receive your announcements.`,
  }),
  PENDING: (name: string) => ({
    h1: `${name} needs to finish setting up their account to have conversations on Remind.`,
    h2: 'They will still receive your announcements.',
  }),
  UNKNOWN: (name: string) => ({
    h1: `${name} is unavailable for conversations on Remind.`,
    h2: 'They will still receive your announcements.',
  }),
  UNAVAILABLE: (name: string) => ({
    h1: `${name} is unavailable for conversations on Remind.`,
    h2: 'They will still receive your announcements.',
  }),
  UNDER_13_SHORT: 'Is under age 13',
  PENDING_SHORT: 'Must complete account setup',
  UNKNOWN_SHORT: 'Unavailable for conversations',
  UNAVAILABLE_SHORT: 'Unavailable for conversations',
  INELIGIBLE: 'Unable to have conversations',
};

export function shortDescriptionForChatEligibilityState(state: string) {
  switch (state) {
    case 'under_13':
      return ChatIneligibleCopy.UNDER_13_SHORT;
    case 'pending':
      return ChatIneligibleCopy.PENDING_SHORT;
    case 'unknown':
      return ChatIneligibleCopy.UNKNOWN_SHORT;
    default:
      return ChatIneligibleCopy.UNAVAILABLE_SHORT;
  }
}

export const MessageNullState = {
  secondHeader:
    "You'll be able to see your message history here — and so can your administrator, so just keep that in mind. 👀",
};
